<template>
    <header class="header-auth">
        <div class="navs w">
            <div class="nav_logo">
                <a :href="config.special_url" target="_blank">
                    <img :src="config.logo" :alt="config.site_title" style="width: 150px;" />
                </a>

                <div class="title" v-if="title">{{ title }}</div>
            </div>

            <div class="fr nav-right">
                <i class="iconfont icon-lianxifangshilogo tel"></i>
                <div>
                    <div>24小时免费咨询</div>
                    <div>
                        <a :href="config.chat_url" target="_blank" class="link active">{{ config.tel }}</a>
                    </div>
                </div>
            </div>
        </div>
    </header>
</template>

<script>
    export default {
        props: {
            title: {
                default: null,
            },
        },
    };
</script>
<style lang="less" scoped>
    .header-auth {
        width: 100%;
        border-bottom: 1px solid #eaeaea;
        .nav_logo {
            display: flex;
            align-items: center;
            .title {
                font-size: 24px;
                margin-left: 24px;
                border-left: 1px solid #111;
                padding-left: 24px;
            }
        }
        .header-top {
            color: #555555;
            background-color: #f5f5f5;
            height: 38px;
        }

        .header-top > .w > p {
            margin-top: 13px;
            font-size: 12px;
        }

        .header-top > .w {
            overflow: hidden;
        }

        .navs {
            display: flex;
            height: 68px;
            align-items: center;
            justify-content: space-between;
        }

        .navs .nav_logo > a {
            display: flex;
            align-items: center;
        }

        .navs .nav-right {
            display: flex;
            justify-content: space-between;
        }

        .navs .nav-right > div > div:first-child {
            font-size: 12px;
        }

        .navs .nav-right > div > div:nth-child(2) {
            font-size: 18px;
            font-weight: 700;
        }

        .navs .nav-right > div {
            margin-left: 7px;
        }

        .checkbox {
            margin-left: 135px;
            margin-top: 30px;
        }
    }
</style>
